import React from "react";
import { withRouter } from "react-router-dom";

import constants from "../../../util/constants";

const AcceptedInvitation = withRouter(({ history }) => {
  const rotatingSuccessImage = () => {
    const { genericSuccessContent } = constants;

    const randSuccessContent =
      genericSuccessContent[
        Math.floor(Math.random() * genericSuccessContent.length)
      ];
    return randSuccessContent.imageURL;
  };

  return (
    <div style={{ display: "flex", padding: "30px 20px" }}>
      <div style={{ width: 150, display: "flex" }}>
        <img
          src={rotatingSuccessImage()}
          alt="Success"
          style={{ height: 120, margin: "auto", maxWidth: 150 }}
        />
      </div>
      <div className="bold" style={{ margin: "auto 0", padding: 20 }}>
        <br />
        <div>This invitation has already been accepted.</div>
        <br />
        <div>
          <span
            className="link pseudo-link"
            onClick={() => history.push("/login")}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            Sign in here
          </span>
          {" "}
          with your email and password.
        </div>
      </div>
    </div>
  );
});

export default AcceptedInvitation;
